import SET_BANNER from './types';
import Banner from '../queries/banner';

export default ({ commit, state }) => {
  if (state.fetched) {
    return;
  }

  Banner.fetch()
    .then((response) => {
      const { banner } = response.data.current_user_info.group.project;
      return commit(SET_BANNER, banner);
    });
};



// WEBPACK FOOTER //
// ./src/shared/components/banner/store/actions.js